export default function truncateNDecimals(str, n) {
  return str.includes('.') ? str.slice(0, (str.indexOf('.')) + (n + 1)) : str;
}
